module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/brave.616f0b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/brave.jpg
// module id = JFCN
// module chunks = 0